import { BaseServiceRequestDto } from "./dto/request/BaseServiceRequest.dto";
import GeneralServices from "./GeneralServices";
import {
  IGetUserPrivileges,
  IGetUserPrivilegesResponseOk,
  IGetPrivilegesListResponseOk,
  IPostUserPrivileges,
  IPostUserPrivilegesResponseOk,
  IResponseError,
  IUpdatePrivilegesByFile,
  IUpdatePrivilegesByFileResponseOk,
} from "./PrivilegesServices-dto";

class PrivilegesServices {
  getUserPrivileges = async ({
    setLoading,
    loader,
    user,
  }: IGetUserPrivileges): Promise<IGetUserPrivilegesResponseOk | IResponseError> => {
    try {
      const response = await GeneralServices.get({
        setLoading,
        loader: !!loader,
        endpoint: `privileges/getUserPrivileges${user ? `?user=${user}` : ""}`,
      });
      return {
        ok: true,
        data: response.data,
      };
    } catch (error) {
      return {
        error: true,
        message:
          typeof error === "string" ? error : "Se ha producido un error, inténtelo más tarde.",
      };
    }
  };

  getPrivilegesList = async ({
    setLoading,
    loader,
  }: BaseServiceRequestDto): Promise<IGetPrivilegesListResponseOk | IResponseError> => {
    try {
      const response = await GeneralServices.get({
        setLoading,
        loader,
        endpoint: "privileges/privilegesList",
      });
      return {
        ok: true,
        data: response.data,
      };
    } catch (error) {
      return {
        error: true,
        message:
          typeof error === "string" ? error : "Se ha producido un error, inténtelo más tarde.",
      };
    }
  };

  postUserPrivileges = async ({
    setLoading,
    loader,
    data
  }: IPostUserPrivileges): Promise <IPostUserPrivilegesResponseOk | IResponseError> => {
    try {
      if (!data.user) throw new Error("Por favor, añada un usuario.");

      const response = await GeneralServices.post({
        setLoading,
        loader,
        data,
        endpoint: "privileges/updateUserPrivileges"
      });
      return {
        ok: true,
        data: response.data,
      }
    } catch (error) {
      return {
        error: true,
        message:
          typeof error === "string" ? error : "Se ha producido un error, inténtelo más tarde.",
      };
    }
  }

  updatePrivilegesByFile = async ({
    setLoading,
    loader,
    file,
  }: IUpdatePrivilegesByFile): Promise<IUpdatePrivilegesByFileResponseOk | IResponseError> => {
    try {
      const fd = new FormData();
      fd.append("file", file);

      const response = await GeneralServices.postFormData({
        setLoading,
        loader,
        isSlowProcess: false,
        data: fd,
        endpoint: "privileges/upload-privileges",
      });

      return {
        ok: true,
        result: response.status === 200 ? "exit" : "error",
        data: response.data,
      };
    } catch (error) {
      const typedError = error as { data: { message: string } };
      const errorMsg = typedError.data && typedError.data.message;
      return {
        error: true,
        message: typeof errorMsg === "string" ? errorMsg : "Error en la subida de privilegios.",
      };
    }
  };
}

export default new PrivilegesServices();
